<div class="explore-all-container">
  <div *ngIf="islandsData.length > 0" class="island-preview-container">
    <div
      *ngFor="let island of islandsData; let i = index"
      class="island-preview"
      [class.island-preview-hidden]="i !== islandIndex"
    >
      <img [src]="island.image" alt="{{ island.name }}" class="island-preview-image" loading="lazy" decoding="async" />
    </div>
  </div>
  <div class="ishead banner-width">
    <div class="explore-head">
      <div class="explore-div">
        <div *ngFor="let island of islandsData; let i = index; let isLast = last" class="island-img">
          <div style="flex: 1" class="vertical-line"></div>
          <div
            class="page-number"
            [ngStyle]="{
              width: i === islandIndex ? '25px' : '14px',
              height: i === islandIndex ? '25px' : '14px',
              'background-color': i === islandIndex ? 'rgba(255, 255, 255, 0.5)' : ''
            }"
            [class.active]="i === islandIndex"
            (click)="navigateToIsland(i)"
          >
            <span *ngIf="i === islandIndex">{{ i + 1 }}</span>
          </div>
          <div style="flex: 1" class="vertical-line"></div>
        </div>
      </div>
      <div *ngIf="islandsData.length > 0" class="content-wrapper">
        <div class="idiv">
          <div class="island-content">
            <h1 class="island-name" [style.fontSize.vmin]="dynamicFontSize">
              {{ islandsData[islandIndex]?.name }}
            </h1>

            <div class="description-wrapper">
              <div class="island-description" [class.expanded]="isDescriptionExpanded">
                <span [innerHTML]="islandsData[islandIndex]?.description"></span>
              </div>

              <button class="see-more-btn" (click)="toggleDescription()" type="button">
                <span>{{ (isDescriptionExpanded ? 'Read Less' : 'Read More') | translate }}</span>
                <i class="pi" [ngClass]="isDescriptionExpanded ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
              </button>
            </div>
          </div>
          <div class="button-div">
            <div class="button-row">
              <button (click)="exploreNow()" class="routing-btn explore-btn" type="button">
                <span translate>Explore Now</span>
              </button>
              <button type="button" (click)="fullScreen()" class="routing-btn routing-btn-outline">
                <span translate>View Full Screen</span>
              </button>
              <div class="nav-buttons-group">
                <button type="button" (click)="goToPrevIsland()" style="outline: 0px" class="nav-btn" aria-label="prev">
                  <i class="pi pi-chevron-left"></i>
                </button>
                <button type="button" (click)="goToNextIsland()" style="outline: 0px" class="nav-btn" aria-label="Next">
                  <i class="pi pi-chevron-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="slider-div">
          <app-banner-category-slider
            [currentIndex]="islandIndex"
            [categoryData]="islandsData"
            (onCategorySelection)="onCategorySelection($event)"
          ></app-banner-category-slider>
        </div>
      </div>
    </div>
  </div>
</div>
